import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { ImportingJob, JobStatusType } from 'features/jobs/types'
import { useIntl } from 'react-intl'
import { useMutation } from 'react-query'
import { cancelImportingJobMutationDef } from 'features/jobs/models/importJobsModel'
import { getNodePath } from 'features/data-explorer/utils'
import JobImportingItemUi from './JobImportingItemUi'
import { createDialogOpener } from 'features/dialogs/openDialog'

const openErrorDetailsDialog = createDialogOpener(() => import('../common/JobErrorDetailsDialog'))
const openJobCancelDialog = createDialogOpener(() => import('../common/JobCancelDialog'))

function JobImportingItem({
  job,
  onClose,
  inlineMode = false
}: {
  job: ImportingJob
  onClose?: () => void
  inlineMode?: boolean
}) {
  const intl = useIntl()
  const navigate = useNavigate()

  const { mutate: cancelJob, isSuccess: cancelSucceded } = useMutation(cancelImportingJobMutationDef)

  useEffect(() => {
    if (cancelSucceded) {
      onClose && onClose()
    }
  }, [cancelSucceded, onClose])

  const handleJobItemClick = () => {
    if (job.status === JobStatusType.Success) {
      navigate(getNodePath({ id: `${job.destination}.${job.name}`, connectionId: job.connection }))
      if (onClose) {
        onClose()
      }
    } else if (job.status === JobStatusType.Failure && !inlineMode) {
      openErrorDetailsDialog({
        title: intl.formatMessage({ id: 'jobs.datasets.error.title' }),
        message: intl.formatMessage({ id: 'jobs.tilesets.error.info' }),
        error: job.error
      })
    }
  }

  const handleCancelJob = () => {
    openJobCancelDialog({
      job,
      cancelJob: doCancelJob
    })
  }
  const doCancelJob = () => {
    if (job.connection) {
      cancelJob(job.jobId)
    }
    onClose?.()
  }

  return (
    <JobImportingItemUi job={job} onClick={handleJobItemClick} onCancel={handleCancelJob} inlineMode={inlineMode} />
  )
}

export default JobImportingItem
